import { useEffect, useRef, useState } from 'react';
import { Sheet } from '../components/Sheet.jsx';

const FORMATS = ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'code_39', 'itf'];

/** Barcode-Scan wird nur angeboten, wo der Browser ihn kann (Chrome/Edge auf Android, nicht iOS Safari). */
export const canScan = () => typeof window !== 'undefined' && 'BarcodeDetector' in window && !!navigator.mediaDevices?.getUserMedia;

/**
 * Barcode/EAN mit der Kamera lesen (BarcodeDetector-API, alles lokal im Browser).
 * onCode(code) wird beim ersten erkannten Code aufgerufen.
 */
export function ScanSheet({ onCode, onClose }) {
  const video = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let stream;
    let timer;
    let stopped = false;
    (async () => {
      try {
        const supported = await window.BarcodeDetector.getSupportedFormats?.() ?? FORMATS;
        const detector = new window.BarcodeDetector({ formats: FORMATS.filter((f) => supported.includes(f)) });
        stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false });
        if (stopped) return;
        video.current.srcObject = stream;
        await video.current.play();
        const tick = async () => {
          if (stopped) return;
          try {
            const [hit] = await detector.detect(video.current);
            if (hit?.rawValue) { stopped = true; navigator.vibrate?.(60); onCode(hit.rawValue.trim()); return; }
          } catch { /* einzelnes Bild nicht lesbar */ }
          timer = setTimeout(tick, 250);
        };
        tick();
      } catch (err) {
        setError(err?.name === 'NotAllowedError'
          ? 'Kein Zugriff auf die Kamera. Bitte in den Browser-Einstellungen erlauben.'
          : 'Kamera konnte nicht gestartet werden.');
      }
    })();
    return () => {
      stopped = true;
      clearTimeout(timer);
      stream?.getTracks().forEach((t) => t.stop());
    };
  }, [onCode]);

  return (
    <Sheet title="Barcode scannen" onClose={onClose}>
      <div style={{ position: 'relative', borderRadius: 18, overflow: 'hidden', background: '#000', aspectRatio: '4 / 3' }}>
        <video ref={video} muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover' }} aria-label="Kamerabild" />
        <div aria-hidden="true" style={{ position: 'absolute', left: '12%', right: '12%', top: '40%', height: '20%', border: '3px solid rgba(255,255,255,0.85)', borderRadius: 12 }} />
      </div>
      {error ? <p className="error" role="alert">{error}</p> : <span className="sub" style={{ textAlign: 'center' }}>Barcode auf der Verpackung in den Rahmen halten.</span>}
    </Sheet>
  );
}
